import angular from 'angular';

import * as actions from '../../store/actions';

const mapStateToScope = (state) => ({});

/**
 * @ngdoc function
 * @name myConsultApp.controller:manageRedemptionList
 * @description
 * # manageRedemptionList
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller('manageRedemptionList', ($ngRedux, $rootScope, $scope, $location, $route) => {
    if (!$scope.isAdminUser) {
      $location.path('/');
    }

    $scope.processParams = () => {
      const { redemptionId } = $route.current.params;
      if (!redemptionId) return;
      const beforeRoute = `${$rootScope.routes.redemption}/${redemptionId}`;
      const closeRoute = $rootScope.routes.redemption;
      $scope.showRedemptionDetail({
        redemptionId: redemptionId,
        beforeRoute: beforeRoute,
        closeRoute: closeRoute,
      });
    };

    $scope.generatebeforeRoute = (id) => {
      return `${$rootScope.routes.redemption}/${id}`;
    };

    $scope.init = () => {
      $rootScope.previousRoute = $rootScope.routes.redemption;
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      $scope.processParams();
    };

    $scope.table = {
      name: 'Manage Redemptions',
      options: {
        endpoint: '/2.0/redemptions/',
        endpoint_data_key: 'redemptions',
        per_page_options: [15, 25, 50, 100, 200],
        records_per_page: 15,
        row_style: 'redemption',
        scale_up: false,
        search_key: 'Redemptions',
        search_required: false,
      },
      actions: [
        {
          name: 'Redeem Points for User',
          link: '#',
          onclick: () => {
            $rootScope.openComponent({ component: 'redeem-points' });
          },
          order: 0,
          superuser: false,
        },
      ],
      columns: [
        {
          name: 'Date Redeemed',
          options: {
            content: '{{ record.date_redeemed }}',
            class: '',
          },
        },
        {
          name: 'User',
          options: {
            content:
              '<a ng-if="record.user.first_name || record.user.last_name" href="#" ng-href="/admin/users/manage-users/{{ record.user.id }}">' +
              '{{ record.user.first_name }} {{ record.user.last_name }}' +
              '</a>' +
              '<br ng-if="record.user.contact_information.email && (record.user.first_name || record.user.last_name)" />' +
              '<a ng-class="{\'small email\': (record.user.first_name || record.user.last_name)}" ng-if="record.user.contact_information.email" href="#" ng-href="/admin/users/manage-users/{{ record.user.id }}">' +
              '{{ record.user.contact_information.email }}' +
              '</a>',
            class: '',
          },
        },
        {
          name: 'Status',
          options: {
            content:
              "<span ng-class=\"{ 'error': record.status.name.match('Error') !== null }\">{{ record.status.name }}</span>",
            class: '',
          },
        },
        {
          name: 'Points Redeemed',
          options: {
            content:
              '{{ record.total_points_redeemed || 0 }}' +
              ' <span ng-if="!record.total_points_redeemed" class="bold italic">(pending)</span>',
            class: '',
          },
        },
        {
          name: 'Additional Details',
          options: {
            content: `<span class="bold italic">Redemption ID:</span> {{ record.id }}`,
            class: '',
          },
        },
        {
          name: 'Notes/Action',
          options: {
            content:
              '<div><a ng-href="#" ng-click="showRedemptionDetail({redemptionId: record.id, beforeRoute: generatebeforeRoute(record.id), closeRoute: $root.routes.redemption})">View Redemption Details</a></div>',
            class: '',
          },
        },
      ],
      filters: [
        {
          name: 'User',
          type: 'angucomplete',
          options: {
            class: 'user-filter above-divider',
            query_string_parameter: 'user_id',
            remove_all: true,
            remove_all_key: 'users',
            search_endpoint: '/2.0/users/?groups=2',
            search_endpoint_data_key: 'data',
            selected: [],
            selected_key: ['first_name', 'last_name'],
            selected_remove_key: 'id',
          },
          angucomplete_parameters: {
            id: 'user-name',
            placeholder: 'User Name',
            pause: 1000,
            datafield: 'users',
            isclearafterselect: true,
            selectedobject: 'nameEmail',
            searchfields: 'first_name,last_name,email',
            titlefield: 'first_name,last_name',
            descriptionfield: ['contact_information', 'email'],
            minlength: 2,
            inputclass: 'form-control form-control-small',
            matchclass: 'highlight',
            searchfn: $scope.filterUsers,
            nextfn: $scope.filterUsersPage,
            onselect: $scope.setSelectedUsers,
            preselected: [],
            isUser: true,
          },
        },
        {
          name: 'Divider',
          type: 'divider',
          options: {
            class: '',
            select_all: true,
          },
        },
        {
          name: 'Point Adjustments',
          type: 'single_choice',
          options: {
            choices: {
              All: { type: 'standard', state: true, value: 'all', order: 0 },
              'Custom Amount': {
                type: 'amount',
                state: false,
                value: 'amount',
                amount: '',
                date_field: false,
                order: 1,
                error: false,
              },
              'Custom Range': {
                type: 'range',
                state: false,
                value: 'range',
                from: '',
                to: '',
                date_field: false,
                order: 2,
                error: false,
              },
            },
            class: 'point-adjustments-filter',
            query_string_parameter: 'point_adjustment',
          },
        },
        {
          name: 'Timeframe',
          type: 'single_choice',
          options: {
            choices: {
              'Last 24 Hours': { type: 'standard', state: true, value: 'day', order: 0 },
              'Previous Week': { type: 'standard', state: false, value: 'week', order: 1 },
              'Previous 365 Days': { type: 'standard', state: false, value: 'year', order: 2 },
              All: { type: 'standard', state: false, value: 'all', order: 3 },
              'Custom Range': {
                type: 'range',
                state: false,
                value: 'range',
                from: '',
                to: '',
                date_field: true,
                order: 4,
                error: false,
              },
            },
            class: 'timeframe-filter above-divider',
            query_string_parameter: 'timeframe',
          },
        },
        {
          name: 'Divider',
          type: 'divider',
          options: {
            class: '',
            select_all: true,
          },
        },
        {
          name: 'Atlas Status',
          type: 'multiple_choice',
          options: {
            choices: {},
            choices_endpoint: '/2.0/redemptions/status/?order=name',
            choices_endpoint_data_key: 'redemption-statuses',
            class: '',
            name_attribute: 'name',
            query_string_parameter: 'atlas_status',
            select_all: true,
          },
        },
        {
          name: 'Wirecard Status',
          type: 'multiple_choice',
          options: {
            choices: {
              'No Status': { type: 'standard', state: true, value: 'no_status', order: 0 },
              'Processed Successfully': {
                type: 'standard',
                state: true,
                value: 'processed_successfully',
                order: 1,
              },
              Processing: { type: 'standard', state: true, value: 'processing', order: 2 },
              Verified: { type: 'standard', state: true, value: 'verified', order: 3 },
              'Request Not Found': {
                type: 'standard',
                state: true,
                value: 'request_not_found',
                order: 4,
              },
            },
            class: 'above-divider',
            name_attribute: 'name',
            query_string_parameter: 'wirecard_status',
            select_all: true,
          },
        },
        {
          name: 'Divider',
          type: 'divider',
          options: {
            class: '',
            select_all: true,
          },
        },
        {
          name: 'Redemption Type',
          type: 'multiple_choice',
          options: {
            choices: {
              'Auto-Redemption': { state: true, value: 'auto_redemption', order: 0 },
              'User Redeemed': { state: true, value: 'user_redeemed', order: 1 },
            },
            class: '',
            query_string_parameter: 'redemption_type',
          },
        },
        {
          name: 'Reward',
          type: 'multiple_choice',
          options: {
            choices: {},
            choices_endpoint: '/2.0/rewards/?order=title&paginate=false',
            choices_endpoint_data_key: 'rewards',
            class: 'above-divider scroll-choices',
            name_attribute: 'title',
            no_selected_parameter: 'none',
            query_string_parameter: 'reward',
            select_all: true,
          },
        },
        {
          name: 'Divider',
          type: 'divider',
          options: {
            class: '',
            select_all: true,
          },
        },
        {
          name: 'Quantity Changed',
          type: 'multiple_choice',
          options: {
            choices: {
              Changed: { state: true, value: 'changed', order: 0 },
              'Not Changed': { state: true, value: 'not_changed', order: 1 },
            },
            class: '',
            query_string_parameter: 'quantity_changed',
          },
        },
        {
          name: 'Reward Changed',
          type: 'multiple_choice',
          options: {
            choices: {
              Changed: { state: true, value: 'changed', order: 0 },
              'Not Changed': { state: true, value: 'not_changed', order: 1 },
            },
            class: 'above-divider',
            query_string_parameter: 'reward_changed',
          },
        },
        {
          name: 'Divider',
          type: 'divider',
          options: {
            class: '',
            select_all: true,
          },
        },
        {
          name: 'User Notification Status',
          type: 'multiple_choice',
          options: {
            choices: {
              Sent: { state: true, value: 'sent', order: 0 },
              'Not Sent/Failed': { state: true, value: 'not_sent', order: 1 },
            },
            class: '',
            query_string_parameter: 'user_notification_status',
          },
        },
        {
          name: 'Error Notification Status',
          type: 'multiple_choice',
          options: {
            choices: {
              Sent: { state: true, value: 'sent', order: 0 },
              'Not Sent/Failed': { state: true, value: 'not_sent', order: 1 },
            },
            class: '',
            query_string_parameter: 'error_notification_status',
          },
        },
      ],
      sort_options: {
        date_redeemed: {
          state: true,
          value: '-1',
          title: 'Date Redeemed',
          order: 0,
        },
        status__name: {
          state: false,
          value: '1',
          title: 'Redemption Status',
          order: 1,
        },
        total_points_redeemed: {
          state: false,
          value: '-1',
          title: 'Redemption Points',
          order: 2,
        },
      },
    };

    $scope.init();

    $scope.$on('$routeChangeStart', async (event, current) => {
      if (!current?.params?.redemptionId) {
        $rootScope.userId = null;
      }
    });

    $scope.$on('$destroy', $scope.unsubscribe);
  });
